import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import NavLink from '../nav_link';

const styles = () => ({
    topic: {
        paddingLeft: '32px',
        maxHeight: '40px',
        paddingRight: '1.0rem',
    },
});
class JetListGeneral extends React.Component {
    render() {
        const { classes } = this.props;

        return (
            <React.Fragment>
                <Collapse component="li" in={this.props.isOpen} timeout="auto">
                    <List disablePadding>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/general/overview"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Product Overview" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/general/system-requirements"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="System Requirements" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/general/special-characters"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Special Characters" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/general/jet-media-shuttle-workflow"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Media Shuttle Workflows" />
                            </ListItem>
                        </NavLink>
                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/general/iperf"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Testing Transfer Speed" />
                            </ListItem>
                        </NavLink>

                        <NavLink
                            onClick={this.props.handleDrawerToggle}
                            onActive={this.props.onActive}
                            to="/jet/general/sdcx-release-notes"
                        >
                            <ListItem button className={classes.topic}>
                                <ListItemText secondary="Download SDCX Server" />
                            </ListItem>
                        </NavLink>
                    </List>
                </Collapse>
            </React.Fragment>
        );
    }
}

JetListGeneral.propTypes = {
    classes: PropTypes.object.isRequired,
    isOpen: PropTypes.object,
    onActive: PropTypes.func,
    handleDrawerToggle: PropTypes.func,
};

export default withStyles(styles)(JetListGeneral);
